import PropTypes, { any } from 'prop-types';
import React from 'react';
import styles from '../search.scss';
import Filter, { FilterModal, FilterSection } from './Filter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';

const DivisionFilter = (props) => {
    const { type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, customOptions, placeholder, 'data-testid': dataTestId } = props;

    const divisionList = customOptions ? customOptions.division : searchTypes.divisions;
    const selectedDivisionValue = filters.division && divisionList.find(v => v.value === filters.division);
    const collegeCornerFilterValue = selectedDivisionValue?.description ? selectedDivisionValue.description : 'All divisions';
    const filterName = 'division';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                searchFor={type}
                handleFilterClick={handleFilterClick}
                isActive={(filters.division) || filterModal === filterName}
                onClick={() => handleFilterClick(filterName)}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {type === 'collegeCorner' ? collegeCornerFilterValue : 'Division'}
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Division'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <DropdownFilter
                            options={divisionList}
                            selected={filterInputs.division}
                            placeholder={placeholder}
                            onChange={(division) => {
                                handleFilterUpdate({ division });
                            }}
                            data-testid={dataTestId && `${dataTestId}.dropdown`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

DivisionFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    searchTypes: PropTypes.objectOf(any),
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    customOptions: PropTypes.objectOf(any),
    placeholder: PropTypes.string,
    'data-testid': PropTypes.string,
};

DivisionFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterSubmit: () => { },
    searchTypes: null,
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    customOptions: null,
    placeholder: 'Any Division',
    'data-testid': undefined,
};

export default DivisionFilter;
